// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/tsb-reportable-accidents.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/tsb-reportable-accidents/tsb-reportable-accidents.js';

mount([g0]);
